import { PiCalendarBlank, PiTicket } from 'react-icons/pi';
import { CiLocationOn } from 'react-icons/ci';
import { useLocation } from 'react-router-dom';
import EventDTO from '../models/event';
import Button from './atoms/Button';
import { parseFriendlyDate } from '../utils/dates';
import LoadingText from './atoms/LoadingText';
import { useGetEventCapacityQuery } from '../store/apis/events';
import useGetUserRole from '../hooks/useGetUserRole';

interface EventCardProps {
  event: EventDTO;
  onSelect: (eventId: string) => void;
  colorToast?: string;
  textButton?: string;
  textToast?: string;
  adminEvents?: boolean;
  hideButton?: boolean;
}

const LandingEventCard: React.FC<EventCardProps> = ({
  event, onSelect, colorToast = 'bg-warning', textToast, textButton = 'Adquirir entradas', adminEvents, hideButton = false,
}) => {
  let content;
  const location = useLocation();
  const isBackoffice = location.pathname.includes('admin');
  if (adminEvents) {
    const role = useGetUserRole();
    const { data: capacity, isFetching: isFetchingCapacity } = useGetEventCapacityQuery({ eventId: event.id, businessId: event.business_id });
    const ticketsSold = event.tickets.reduce((pv, cv) => pv + (cv?.amount_taken ?? 0), 0);
    content = (role === 'ADMIN' || role === 'ROOT') && adminEvents && (
      <div className="flex items-center text-text-secondary text-md-medium break-words whitespace-normal text-center">
        <PiTicket className="mr-1 text-md-medium" />
        <LoadingText
          text={`${capacity?.used_tickets ?? '?'}/${ticketsSold} tickets vendidos`}
          isLoading={isFetchingCapacity}
        />
      </div>
    );
  }

  return (
    <div onClick={() => onSelect(isBackoffice ? event.id : event.slug)}
      className="group flex flex-col items-center w-full h-full p-3 rounded-3xl landing-event-card-shadow bg-blur-lg bg-opacity-heavy gap-3 cursor-pointer">
      <div className="w-full relative rounded-2xl">
        {textToast && <div className={`${colorToast} p-1 rounded-3xl w-fit absolute right-0 top-0 z-10 text-sm-medium ${colorToast === 'bg-warning-300' ? 'text-text-primary' : ''}`}>{textToast}</div>}
        <div className='overflow-hidden rounded-2xl'>
          <img
            src={
              event.banner_image
              || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMsG_C_QzoMZzPjUrOATtYljG9I3dBybHwjS7yAuDw1w&s'
            }
            alt={event.name}
            className={'w-full object-cover rounded-2xl aspect-[1920/700] group-hover:scale-105 transition-all duration-300'}
          />
        </div>
      </div>

      <div className="flex flex-col items-center w-full gap-3 h-full">
        <div className='w-full'>
          <h2 className="text-xl-semibold text-text-primary break-words whitespace-normal text-center overflow-hidden text-ellipsis" style={{ maxWidth: '100%', whiteSpace: 'nowrap' }}>{event.name}</h2>
        </div>
        <p className="text-text-secondary text-sm-regular">Organiza: {event.business_name}</p>
        <p className="flex items-center text-text-secondary text-md-medium">
          <PiCalendarBlank className="mr-1 text-md-medium" />
          {parseFriendlyDate(event.date, true, true)}
        </p>
        <p className="flex items-center text-text-secondary text-md-medium break-words whitespace-normal text-center">
          <CiLocationOn className="mr-1 text-md-medium " />
          {event.place}
        </p>
        {content}
        {!hideButton ? <div className='flex h-full items-end w-fit mb-3'>
          <Button
            variant="secondary"
            disabled={!adminEvents && !event.active}
          >
            {textButton}
          </Button></div> : null}
      </div>
    </div>
  );
};

export default LandingEventCard;
